import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2'

import Loader from '../../Loader/Loader';

import { getTokenInfo } from '../../../UseToken';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	content_language,
} from '../../../Utils';

import { language } from './Language';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)
	const [/*editorLoaded*/, setEditorLoaded] = useState(false);

	const [refresh, setRefresh] = useState(0);
	
	const [new_menu, set_new_menu] = useState('');
	const [new_menu_link, set_new_menu_link] = useState('');
	const [new_menu_parent, set_new_menu_parent] = useState('');

	const [menus_avaiable, set_menus_avaiable] = useState([])
	const [menus_selected, set_menus_selected] = useState([])
	const [treeData, setTreeData] = useState([]) 

	const [modal_id, set_modal_id] = useState('');
	const [modal_title, set_modal_title] = useState('');
	const [modal_link, set_modal_link] = useState('');
	const [modal_parent, set_modal_parent] = useState('');
	const [modal_language, set_modal_language] = useState([]);

	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				setTreeData(dados.current.content.childs);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	/*const get_menu_childs = async (parent) => {
		return await reqGET(`${api_crud_base}/web/content/parent/${getTokenInfo().companycode}/${parent}`)
			.then(res => {
				console.log(res.data)
			})
			.catch(error => console.log(error))
	}*/

	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}

	useEffect(() => {
		//setEditorLoaded(true);
		clean_data();

		//set_menus_avaiable([]); 
		let m_avaiable = []

		set_lang(localStorage.getItem('lang'))

		setTreeData([]);

		const order_menu = (parent, array, array2) => {
			let array_aux = array.filter(v => v.info.parent === parent)
			array_aux.forEach(v => {
				array2.push(v)
				order_menu(v.id, array, array2)
			})
		}

		const get_menus_avaiable = async (type) => {
			return await reqGET(`${api_crud_base}/web/content/type/${getTokenInfo().companycode}/${type}`)
				.then(res => {
	
					let array_aux = m_avaiable
					order_menu('0', res.data, array_aux)
					// console.log(array_aux)
					set_menus_avaiable(array_aux);
					
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}

		get_menus_avaiable('content')
			.then(() => {
				get_menus_avaiable('multipage')
				.then(() => {
					let array_aux = []
					order_menu('0', m_avaiable, array_aux)
					set_menus_avaiable(array_aux);
				})
			})

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false);
					setEditorLoaded(true);
				})
				return			
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
			
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		dados.current.content.childs = treeData

		if (is_edit === true) {
			//alert('Atualizar PUT')
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => console.log('Problema ao atualizar Registo!'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPOST(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => alert('Problema ao atualizar Registo!'))
				}
			})
		}
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(res => {
						props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
	};

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		if(name === 'principal')
			set_dados(dados.current.info[name] = !dados.current.info[name])
		else
			set_dados(dados.current.info[name] = value)
		
		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const max_id_array = (array) => {
		let max_value = Math.max.apply(Math, array.map(function(o) { return o.id; }))

		array.forEach(v => {
			if(v.children && v.children.length > 0) {
				let max_value_2 = max_id_array(v.children)

				if(max_value_2 > max_value)
					max_value = max_value_2
			}
		})

		return max_value
	}

	const get_parent_depth = (parent, prefix) => {
        let aux = menus_avaiable.filter(v => v.id === parent)
        if(aux.length > 0) {
            prefix += '-'
            return get_parent_depth(aux[0].info.parent, prefix)
        }
        else {
            return prefix
        }
    }

	const add_menu = (obj) => {
		let max_value = 0
		if(treeData.length > 0)
			max_value = max_id_array(treeData)

		setTreeData([...treeData, { id: ++max_value, id_content: obj.id, title: obj.info.name, subtitle: '', slug: obj.info.slug, link: '', language: [] }])
		set_menus_selected([...menus_selected, obj])
		//set_menus_avaiable(menus_avaiable.filter(v => v.id !== obj.id))
	}

	const add_menu_2 = (name, link, parent) => {
		let max_value = 0
		if(treeData.length > 0)
			max_value = max_id_array(treeData)

		if(name !== '' && link !== '') {
			setTreeData([...treeData, { id: ++max_value, id_content: '', title: name, subtitle: link, slug: '', link: link, parent: parent, language: [] }])
			set_new_menu('')
			set_new_menu_link('')
			set_new_menu_parent('')
			// set_menus_selected([...menus_selected, obj])
			//set_menus_avaiable(menus_avaiable.filter(v => v.id !== obj.id))
		}
		else {
			Swal.fire(language[lang].empty_error, '', 'info')
		}
	}

	const handle_change_tree = (treeData) => {
		setTreeData(treeData)
		//console.log(treeData)
	}

	const remove_element_array = (id, array) => {
		array = array.filter(v => v.id !== id)
		array.forEach(v => {
			if(v.children && v.children.length > 0) {
				v.children = remove_element_array(id, v.children)
			}
		})

		return array
	}

	const remove_element_tree = (id) => {
		let treeAux = remove_element_array(id, treeData)
		setTreeData(treeAux)

		//let obj2delete = menus_selected.filter(v => v.id === id)
		//set_menus_avaiable([...menus_avaiable, obj2delete[0]])
		set_menus_selected(menus_selected.filter(v => v.id !== id))
	}

	const edit_element_tree = (id) => {

		treeData.forEach((v) => {
			if(v.id === id) {
				set_modal_id(id)
				set_modal_title(v.title)
				set_modal_link(v.link)
				set_modal_parent(v.parent)
				if(v['language'] !== undefined)
					set_modal_language(v['language'])
			}
			else if(v.children !== undefined && v.children.length > 0) {
				v.children.forEach((vC) => {
					if(vC.id === id) {
						console.log('vC', vC)
						set_modal_id(id)
						set_modal_title(vC.title)
						set_modal_link(vC.link)
						set_modal_parent(vC.parent)
						if(v['language'] !== undefined)
							set_modal_language(v['language'])
					}
				})
			}
		})

	}

	const handleChangeMenu = (e) => {
		const { value, name, dataset } = e.target;
		const { langid, lang } = dataset

		if(langid === 1 || langid === '1') {
			if(name === 'title') {
				set_modal_title(value)
			}
		}
		else {
			if(name === 'title') {
				if(modal_language[langid] === undefined)
					modal_language[langid] = { id: langid, code: lang }

				modal_language[langid][name] = value
			}
		}

		if(name === 'link') {
			set_modal_link(value)
		}

	}

	const handleEditMenu = () => {

		let aux = treeData
		aux.forEach((v) => {
			if(v.id === modal_id) {
				v.title = modal_title
				v.link = modal_link
				v.subtitle = modal_link
				v.parent = modal_parent
				v['language'] = modal_language
			}
			else if(v.children !== undefined && v.children.length > 0) {
				v.children.forEach((vC) => {
					if(vC.id === modal_id) {
						vC.title = modal_title
						vC.link = modal_link
						vC.subtitle = modal_link
						vC.parent = modal_parent
						vC['language'] = modal_language
					}
				})
			}
		})
		console.log(aux)

		setTreeData(aux)
		setRefresh(refresh + 1)

	}

	const handleSingleCheck = e => {

		if(dados.current.info.principal === true)
			dados.current.info.principal = false
		else
			dados.current.info.principal = true

		return
	}

	return (isloading ?

		<Loader />
		
		:

		<main>
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{dados.current.info.name.length > 0 ? language[lang].menu_edit : language[lang].menu_new}</h2>
					<p>{language[lang].structure} / { dados.current.id !== '' ? language[lang].menu_edit : language[lang].menu_new }</p>
				</div>
		
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="col-md-8 mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].menu}</h3>
										</div>
									</div>
									<div>
										<div className="card-body border-top p-4">
											<div className="row mb-6">
												<div className="col-12">
													<label className="col-form-label required fw-bold fs-6">{language[lang].name}</label>
													<input type="text" name="name" value={dados.current.info ? dados.current.info.name : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].childs}</h3>
										</div>
									</div>
									<div>
										<div className="card-body border-top p-4">
											<div className="row mb-6">


												<div className="col-6 mb-5 mb-xl-10">
													<div className="mb-3">
														<div className="fw-bold mb-3">
															<span className="fs-6 fw-bolder text-gray-900">
																<input type="text" name="new_menu" value={new_menu} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].name_placeholder} onChange={(e) => set_new_menu(e.target.value)} />
															</span>
														</div>

														<div className="fw-bold mb-3">
															<span className="fs-6 fw-bolder text-gray-900">
																<input type="text" name="new_menu_link" value={new_menu_link} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].link_placeholder} onChange={(e) => set_new_menu_link(e.target.value)} />
															</span>
														</div>

														<div className="mb-3 ">
															<select className="form-select rounded-0" aria-label="Select Parent" name='parent' defaultValue={new_menu_parent} onChange={(e) => set_new_menu_parent(e.target.value)}>
																<option value="0">---</option>
																{
																	menus_avaiable.map((v, k) => {
																		return (
																			<option key={k} value={v.id}>{get_parent_depth(v.id, '')} {v.info.name}</option>
																		)
																	})
																}
															</select>
														</div>
														
														<div className="fw-bold text-right mb-3">
															<button type="button" onClick={() => add_menu_2(new_menu, new_menu_link, new_menu_parent)} className="btn btn-sm btn-icon btn-secondary rounded-0 ms-auto" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
																Adicionar
															</button>
														</div>
													</div>
												</div>
											</div>
											
											<div className="row mb-6">
												<div className="col-md-6 mb-5 mb-xl-10">

													<div className="card card-flush h-lg-100">
														<div className="card-header mt-6">
															<div className="card-title flex-column">
																<h3 className="fw-bolder mb-1">{language[lang].pages}</h3>
																<div className="fs-6 text-gray-400"></div>
															</div>
															<div className="card-toolbar">
															</div>
														</div>
														<div className="card-body d-flex flex-column mb-9 p-4 pt-3">
															{
															menus_avaiable.map((v, k) => {
																return (
																	<div key={k} className="d-flex align-items-center position-relative mb-3">
																		<div className="position-absolute top-0 start-0 rounded h-100 bg-secondary w-4px"></div>
																		<div className="fw-bold ms-6">
																			<span className="fs-6 fw-bolder text-gray-900">{get_parent_depth(v.info.parent, '')} {v.info.name}</span>
																		</div>
																		<button type="button" onClick={() => add_menu(v)} className="btn btn-sm btn-icon btn-secondary rounded-0 ms-auto" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
																			<i className="bi bi-plus fs-4"></i>
																		</button>
																	</div>
																	
																)
															})
															}
														</div>
													</div>

												</div>

												<div className="col-md-6 mb-5 mb-xl-10">

													<div className="card card-flush h-lg-100">
														<div className="card-header mt-6">
															<div className="card-title flex-column">
																<h3 className="fw-bolder mb-1">{language[lang].menu}</h3>
																<div className="fs-6 text-gray-400"></div>
															</div>
															<div className="card-toolbar">
															</div>
														</div>
														<div className="card-body d-flex flex-column mb-9 p-9 pt-3">
															<SortableTree
																isVirtualized={false}
																maxDepth={2}
																treeData={treeData}
																onChange={treeData => handle_change_tree(treeData)}
																getNodeKey={({ node }) => node.id}
																generateNodeProps={extendedNode => ({
																	title: (
																		<a href={extendedNode.node.url} target="_blank" rel="noreferrer">{extendedNode.node.title}</a>
																	),
																	buttons: [
																		<button type="button" onClick={() => edit_element_tree(extendedNode.node.id)} className={"btn btn-icon btn-bg-light btn-active-color-danger btn-sm" + (extendedNode.node.id_content === '' ? '' : ' d-none')} data-bs-toggle="modal" data-bs-target={"#edit_modal"}><i className="bi bi-pencil-fill"></i></button>,
																		<button type="button" onClick={() => remove_element_tree(extendedNode.node.id)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"><i className="bi bi-trash-fill"></i></button>,
																	],
																})}
															/>
														</div>
													</div>

												</div>

											</div>
											
										</div>
									</div>
								</div>

							</div>

							<div className="col-md-4 mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#div_configuracao" aria-expanded="true" aria-controls="kt_configuracao">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].menu_config}</h3>
										</div>
									</div>
									<div id="divt_configuracao" className="collapse show">
										<div className="card-body border-top p-4">

											<div className="row mb-6">
												<div className="form-check form-check-custom mb-2">
													<label className="form-check-label me-5" htmlFor="principal">
														{language[lang].principal}
													</label>
													<input className="form-check-input" type="checkbox" name="principal" value={dados.current.info.principal} id="principal" onChange={handleSingleCheck} defaultChecked={dados.current.info.principal} />
												</div>
											</div>

											<div className="row mb-6">
												<label className="col-form-label required fw-bold fs-6">{language[lang].type}</label>
												
												<select className="form-select rounded-0" aria-label="Select Type" name='type' defaultValue={dados.current.info.type} onChange={handle_change_info}>
													<option value="H">{language[lang].type_horizontal}</option>
													<option value="V">{language[lang].type_vertical}</option>
												</select>
											</div>

										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>


				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</form>

			<div className="modal bg-light fade" tabIndex="-1" id={"edit_modal"}>
				<div className="modal-dialog modal-lg modal-dialog-centered">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{modal_title}</h5>

							<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
							<i className="bi bi-x fs-2"></i>
							</div>
						</div>

						<div className="modal-body">
							<div className="row mb-6">
								<div className="col-12 d-none">
									<label className="col-form-label fw-bold fs-6">{language[lang].name}</label>
									<input type="text" className="form-control mb-3" name="title" defaultValue={modal_title} data-id={modal_id} onBlur={handleChangeMenu} placeholder={"Nome"} /> 
								</div>

								{
								content_language.map((el_lang, k_lang) => {
									return (
										<div key={k_lang} className="col-6">
											<label className="col-form-label fw-bold fs-6">{language[lang].name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
											<input type="text" className="form-control mb-3" name="title" data-langid={el_lang.id} data-lang={el_lang.code}  defaultValue={el_lang.id === '1' ? modal_title : (modal_language !== undefined && modal_language[el_lang.id] !== undefined && modal_language[el_lang.id]['title'] !== undefined ? modal_language[el_lang.id]['title'] : '')} data-id={modal_id} onBlur={handleChangeMenu} placeholder={"Nome"} /> 
										</div>
									)
								})
								}
							</div>
							<div className="row">
								<div className="col-6">
									<label className="col-form-label fw-bold fs-6">{language[lang].link}</label>
									<input type="text" className="form-control" name="link" defaultValue={modal_link} data-id={modal_id} onBlur={handleChangeMenu} placeholder={language[lang].link_placeholder} /> 
								</div>
								<div className="col-6">
								<label className="col-form-label fw-bold fs-6">{language[lang].parent}</label>
									<select className="form-select rounded-0" data-id={modal_parent} aria-label="Select Parent" name='parent' value={modal_parent} onChange={(e) => set_modal_parent(e.target.value)}>
										<option value="0">---</option>
										{
											menus_avaiable.map((v, k) => {
												return (
													<option key={k} value={v.id}>{get_parent_depth(v.id, '')} {v.info.name}</option>
												)
											})
										}
									</select>
								</div>
							</div>
						</div>

						<div className="modal-footer">
							<button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
							<button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleEditMenu}>{language[lang].edit}</button>
						</div>
					</div>
				</div>
			</div>

		</main>
	)
}
